import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationStatusEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationByUserId = null;
        this.creationDTTM = null;
        this.id = 0;
        this.title = '';
        this.updatedByUserId = null;
        this.updatedDTTM = null;
    }
    pk() {
        return this.id.toString();
    }
}
OrganizationStatusEntity.schema = {
    creationDTTM: ISODate,
    updatedDTTM: ISODate
};
OrganizationStatusEntity.key = 'OrganizationStatus';
export { OrganizationStatusEntity };
